import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableComponent } from './table/table.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SideNavbarComponent } from './navigation/side-navbar/side-navbar.component';
import { HeaderComponent } from './navigation/header/header.component';
import { ProfileComponent } from './navigation/profile/profile.component';
import { PaginationComponent } from './pagination/pagination.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChildParentHierarchyComponent } from './child-parent-hierarchy/child-parent-hierarchy.component';
import { ProductsDropdownComponent } from './navigation/products-dropdown/products-dropdown.component';
import { ReportTableComponent } from './report-table/report-table.component';
import { AgGridModule } from 'ag-grid-angular';
import { AgGridAngular } from "ag-grid-angular";
import { ButtonCellRendererComponent } from './table/table-components/button-cell-renderer/button-cell-renderer.component';
import { MainTableComponent } from './table/main-table/main-table.component';
import { RowTooltipComponent } from './table/main-table/row-tooltip.component';
import { ErrorPageComponent } from './error-page/error-page.component';
// import { HTTP_INTERCEPTORS } from '@angular/common/http';
// import { ErrorInterceptor } from '../core/interceptor/error.interceptor';
import { DeleteDialogComponent } from './dialogs/delete-dialog/delete-dialog.component';
import { ErrorDialogComponent } from './dialogs/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from './dialogs/success-dialog/success-dialog.component';
import { HierarchicalGridComponent } from './table/hierarchical-grid/hierarchical-grid.component';
import { DetailCellRendererComponent } from './table/hierarchical-grid/detail-cell-renderer/detail-cell-renderer.component';
import { AddChildRendererComponent } from './table/hierarchical-grid/add-child-renderer/add-child-renderer.component';
import { ProcessCompleteDialogComponent } from './dialogs/process-complete-dialog/process-complete-dialog.component';

const components = [
    TableComponent,
    SideNavbarComponent,
    HeaderComponent,
    ProfileComponent,
    PaginationComponent,
    ChildParentHierarchyComponent,
    ReportTableComponent,
    MainTableComponent,
    ButtonCellRendererComponent,
    RowTooltipComponent,
    ErrorPageComponent,
    DeleteDialogComponent,
    SuccessDialogComponent,
    ErrorDialogComponent,
    ProductsDropdownComponent,
    HierarchicalGridComponent,
    DetailCellRendererComponent,
    AddChildRendererComponent
];

// const providers = [
//     {
//       provide: HTTP_INTERCEPTORS,
//       useClass: ErrorInterceptor,
//       multi: true
//     }
// ];

@NgModule({
    declarations: [...components, ProcessCompleteDialogComponent],
    imports: [
        CommonModule,
        MatTooltipModule,
        DragDropModule,
        NgbModule,
        AgGridModule,
        AgGridAngular
    ],
    exports: [...components],
    //providers: [...providers],
})
export class SharedModule {}
